module.exports = __webpack_public_path__ + "catalog/items/firesafety/Running-Man-Door-Symbol-Right/Running-Man-Door-Symbol-Right.svg";